// extracted by mini-css-extract-plugin
module.exports = {"list":"NotSignedInMobileHeaderRightDropdownMenuList_list__wExzC","sending":"NotSignedInMobileHeaderRightDropdownMenuList_sending__3FDJX"};